<div class="content">
  <p class="welcome">Hello! <span id="welcome-user">{{username}}</span></p>
</div>